import { render, staticRenderFns } from "./SaleItemInput.vue?vue&type=template&id=5c30cace&scoped=true&lang=pug"
import script from "./SaleItemInput.vue?vue&type=script&lang=js"
export * from "./SaleItemInput.vue?vue&type=script&lang=js"
import style0 from "./SaleItemInput.vue?vue&type=style&index=0&id=5c30cace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c30cace",
  null
  
)

export default component.exports